<div class="enclosure-summary">
  <div class="summary-item" nz-typography>
    <span class="label">Support</span>

    @if (hasSelectedEnclosure()) {
      <span class="value">
        <span class="propositions">
          @for (
            proposition of selectedPropositions();
            let index = $index;
            track proposition.cabinet?.reference ??
              proposition.rack?.reference ??
              index
          ) {
            <span>{{ formatProposition(proposition) }}</span>
          }
        </span>
        <span>|</span>
      </span>
    } @else if (showNoSupport()) {
      <span class="value">
        <span>Tiers: {{ noSupportValues().nbTiers }}</span>
        <span>|</span>
        <span>Rows: {{ noSupportValues().nbRows }}</span>
        <span>|</span>
        <span>Batteries/row: {{ noSupportValues().nbBatteriesByRow }}</span>
        <span>|</span>
        <span
          >Distance between tiers:
          {{ noSupportValues().distanceBetweenTiers }} mm</span
        >
        <span>|</span>
      </span>
    }
    <span class="value">
      <span>Section: {{ cableSectionLabel() }}</span>
      <span>|</span>
      <span>Connecting method: {{ connectingMethodLabel() }}</span>
      <span>|</span>
      <span>Middle point: {{ middlePointLabel() }}</span>
    </span>
  </div>
</div>
